module.exports = __webpack_public_path__ + "static/sport/slide3.ccb8b1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/trea/slide3.png
// module id = IHDB
// module chunks = 0